<template>
  <div class="ph_layout_page">
    <template>
      <slot></slot>
      <Foot></Foot>
    </template>
  </div>
</template>

<script>
import Foot from './Foot.vue'
export default {
  name: 'PageLay',
  data() {
    return {}
  },
  components: {
    Foot
  }
}
</script>

<style lang="scss">
.ph_layout_page {
  background: #f7f7f7;
  padding-top: 56px;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/PageLay.vue